var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCinema(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.814,
    height: 73.158,
    viewBox: "0 0 84.814 73.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".za{fill:#ffeb00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "za",
    d: "M2.808,30.951H8.04A13.459,13.459,0,0,1,27.654,12.819,18.292,18.292,0,1,1,58.3,30.951H63.5a2.818,2.818,0,0,1,2.817,2.817v4.615l14.248-7.047a2.821,2.821,0,0,1,4.241,2.43V70.342a2.821,2.821,0,0,1-4.061,2.519L66.315,65.726v4.615A2.818,2.818,0,0,1,63.5,73.158H2.807A2.818,2.818,0,0,1-.01,70.342V33.768a2.818,2.818,0,0,1,2.817-2.817Zm34.97,9.859a2.281,2.281,0,0,1,0,4.562H35.416a2.281,2.281,0,0,1,0-4.562ZM9.541,45.372a2.281,2.281,0,0,1,0-4.562H27.828a2.281,2.281,0,0,1,0,4.562Zm21.228-15.74a13.546,13.546,0,0,1-.835,1.318h1.984Q31.313,30.321,30.769,29.633Zm14.343,1.318A12.659,12.659,0,1,0,32.452,18.292,12.641,12.641,0,0,0,45.111,30.951Zm-26.126,0a7.834,7.834,0,1,0-7.834-7.834A7.818,7.818,0,0,0,18.985,30.951Zm47.331,13.7v14.8l12.855,6.357V38.294L66.316,44.652Zm-5.634-8.068H5.625v30.94H60.682V36.585Z",
    transform: "translate(0.01 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinema);
export default __webpack_public_path__ + "static/media/cinema.b66171c5.svg";
export { ForwardRef as ReactComponent };